import React from 'react';
import { pxToRem } from '@noths/polaris-client-styles';
export var Banner = function Banner(_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    roundedCorners = _ref.roundedCorners;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "banner",
    style: {
      backgroundColor,
      borderRadius: roundedCorners ? pxToRem(10) : 0
    }
  }, children);
};